"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const dequal_1 = __importDefault(require("dequal"));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isPrimitive = (val) => val === null || /^[sbn]/.test(typeof val);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const checkDeps = (deps) => {
    if (!deps || !deps.length) {
        throw new Error("useDeepCompareEffect should not be used with no dependencies. Use React.useEffect instead.");
    }
    if (deps.every(isPrimitive)) {
        throw new Error("useDeepCompareEffect should not be used with dependencies that are all primitive values. Use React.useEffect instead.");
    }
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useDeepCompareMemoize = (value) => {
    const ref = react_1.default.useRef();
    if (!dequal_1.default(value, ref.current)) {
        ref.current = value;
    }
    return ref.current;
};
exports.useDeepCompareEffect = (callback, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
dependencies = []) => {
    if (process.env.NODE_ENV !== "production") {
        checkDeps(dependencies);
    }
    react_1.default.useEffect(callback, useDeepCompareMemoize(dependencies));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVlcEVmZmVjdC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy9kZWVwRWZmZWN0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O0FBQUEsa0RBQXlCO0FBQ3pCLG9EQUE4QjtBQUU5Qiw4REFBOEQ7QUFDOUQsTUFBTSxXQUFXLEdBQUcsQ0FBQyxHQUFRLEVBQUUsRUFBRSxDQUFDLEdBQUcsS0FBSyxJQUFJLElBQUksUUFBUSxDQUFDLElBQUksQ0FBQyxPQUFPLEdBQUcsQ0FBQyxDQUFBO0FBRTNFLDhEQUE4RDtBQUM5RCxNQUFNLFNBQVMsR0FBRyxDQUFDLElBQXFCLEVBQUUsRUFBRTtJQUN4QyxJQUFJLENBQUMsSUFBSSxJQUFJLENBQUMsSUFBSSxDQUFDLE1BQU0sRUFBRTtRQUN2QixNQUFNLElBQUksS0FBSyxDQUNYLDRGQUE0RixDQUMvRixDQUFBO0tBQ0o7SUFDRCxJQUFJLElBQUksQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLEVBQUU7UUFDekIsTUFBTSxJQUFJLEtBQUssQ0FDWCx1SEFBdUgsQ0FDMUgsQ0FBQTtLQUNKO0FBQ0wsQ0FBQyxDQUFBO0FBRUQsOERBQThEO0FBQzlELE1BQU0scUJBQXFCLEdBQUcsQ0FBQyxLQUFVLEVBQUUsRUFBRTtJQUN6QyxNQUFNLEdBQUcsR0FBRyxlQUFLLENBQUMsTUFBTSxFQUFFLENBQUE7SUFFMUIsSUFBSSxDQUFDLGdCQUFTLENBQUMsS0FBSyxFQUFFLEdBQUcsQ0FBQyxPQUFPLENBQUMsRUFBRTtRQUNoQyxHQUFHLENBQUMsT0FBTyxHQUFHLEtBQUssQ0FBQTtLQUN0QjtJQUVELE9BQU8sR0FBRyxDQUFDLE9BQU8sQ0FBQTtBQUN0QixDQUFDLENBQUE7QUFFWSxRQUFBLG9CQUFvQixHQUFHLENBQ2hDLFFBQW9CO0FBQ3BCLDhEQUE4RDtBQUM5RCxlQUErQixFQUFFLEVBQ25DLEVBQUU7SUFDQSxJQUFJLE9BQU8sQ0FBQyxHQUFHLENBQUMsUUFBUSxLQUFLLFlBQVksRUFBRTtRQUN2QyxTQUFTLENBQUMsWUFBWSxDQUFDLENBQUE7S0FDMUI7SUFDRCxlQUFLLENBQUMsU0FBUyxDQUFDLFFBQVEsRUFBRSxxQkFBcUIsQ0FBQyxZQUFZLENBQUMsQ0FBQyxDQUFBO0FBQ2xFLENBQUMsQ0FBQSJ9